export default __webpack_public_path__ + "static/typography-image-w-90e9c5864c60a91cab21b4139a20df68.png";